import { useState } from 'react';
import { ClipboardIcon, CheckIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
  size?: 'sm' | 'md';
}

export default function CopyButton({ text, label, className, size = 'md' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const iconSize = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <button
      onClick={handleCopy}
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-md transition-colors',
        size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm',
        copied
          ? 'bg-green-100 text-green-700'
          : 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)] hover:bg-gray-200',
        className
      )}
    >
      {copied ? (
        <>
          <CheckIcon className={iconSize} />
          {label ? 'Copied!' : null}
        </>
      ) : (
        <>
          <ClipboardIcon className={iconSize} />
          {label}
        </>
      )}
    </button>
  );
}
